"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _LineChart = _interopRequireDefault(require("@/components/Charts/LineChart"));
var _DoughnutChart = _interopRequireDefault(require("@/components/Charts/DoughnutChart.vue"));
var chartConfig = _interopRequireWildcard(require("@/components/Charts/chart.config.js"));
var _vuex = require("vuex");
var _auth = require("@/utils/auth");
var _constants = require("@/config/constants");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var now = new Date();
var _default = exports.default = {
  name: 'DashboardDetailsService',
  bodyClass: 'dashboard-details-service-page',
  components: {
    TableServicesActivesCallsList: _components.TableServicesActivesCallsList,
    LineChart: _LineChart.default,
    DoughnutChart: _DoughnutChart.default
  },
  data: function data() {
    return {
      dates: [now, now],
      details: {},
      listLastRequests: [],
      chartData: {},
      chartRequestsTotal: null,
      chartRequestsCompare: null,
      chartRequestsMonetizablesTotal: null,
      listRequestsTotalsxlistRequestM: [],
      chartOptions: _constants.OPTIONS_CHART_DEFAULT,
      loadCards: true,
      loadChart: true,
      loadLastRequests: true,
      loadRequestsTotals: false,
      loadSelectBU: false,
      loadRequestsTotalsMonetizables: false,
      businessUnitList: [],
      businessUnitSelect: null
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['listBusinessUnits'])), {}, {
    user: function user() {
      return (0, _auth.getUser)().user;
    },
    isAdmin: function isAdmin() {
      return this.user.roleAdmin;
    },
    filterItems: function filterItems() {
      return {
        StartDate: (0, _moment.default)(this.dates[0]).format('YYYY-MM-DD'),
        EndDate: (0, _moment.default)(this.dates[1]).add(1, 'days').format('YYYY-MM-DD'),
        businessUnit: this.businessUnitSelect
      };
    },
    titleMonitoramento: function titleMonitoramento() {
      var dateInit = (0, _moment.default)(this.dates[0]);
      var dateEnd = (0, _moment.default)(this.dates[1]);
      var diff = dateInit.diff(dateEnd, 'days');
      if (diff === 0) return 'Monitoramento dos serviços por hora';
      return 'Monitoramento dos serviços por dia';
    },
    totalServicesNow: function totalServicesNow() {
      var _this$details, _this$details$service;
      if ((_this$details = this.details) !== null && _this$details !== void 0 && (_this$details$service = _this$details.services) !== null && _this$details$service !== void 0 && _this$details$service.length) {
        return this.details.services.length;
      }
      return 0;
    },
    servicesName: function servicesName() {
      var _this$details2, _this$details2$servic;
      if ((_this$details2 = this.details) !== null && _this$details2 !== void 0 && (_this$details2$servic = _this$details2.services) !== null && _this$details2$servic !== void 0 && _this$details2$servic.length) {
        var name = '';
        this.details.services.map(function (i) {
          name = "".concat(name, " | ").concat(i, "<br>");
          return i;
        });
        return name;
      }
      return 'Não foram encontrados serviços';
    }
  }),
  mounted: function mounted() {
    this.updateDataItems();
    this.getListAllBUUsernames();
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchDetailServiceDashboard', 'fetchLatestServiceCallDashboard', 'fetchLatestServiceCallChartDashboard', 'fetchLatestServiceCallTotalDashboard', 'fetchLatestServiceCallTotalMonetizablesDashboard', 'fetchLatestServiceCallTotalErrorsDashboard', 'fetchtListAllBUUsernames'])), {}, {
    updateDataItems: function () {
      var _updateDataItems = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.getDetails();
              this.fillChartData();
              this.getDetailsList();
              this.getRequestsTotals();
              this.getRequestsTotalsMonetizables();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function updateDataItems() {
        return _updateDataItems.apply(this, arguments);
      }
      return updateDataItems;
    }(),
    getDetails: function () {
      var _getDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.loadCards = true;
              _context2.n = 1;
              return this.fetchDetailServiceDashboard(this.filterItems);
            case 1:
              data = _context2.v;
              if (data) {
                this.details = data;
              }
              this.loadCards = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getDetails() {
        return _getDetails.apply(this, arguments);
      }
      return getDetails;
    }(),
    getListAllBUUsernames: function () {
      var _getListAllBUUsernames = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.loadSelectBU = true;
              _context3.n = 1;
              return this.fetchtListAllBUUsernames();
            case 1:
              data = _context3.v;
              if (data) {
                this.businessUnitList = data;
              }
              this.loadSelectBU = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function getListAllBUUsernames() {
        return _getListAllBUUsernames.apply(this, arguments);
      }
      return getListAllBUUsernames;
    }(),
    fillChartData: function () {
      var _fillChartData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var data, labels, services, datasets, _loop, i;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              this.loadChart = true;
              _context6.n = 1;
              return this.fetchLatestServiceCallChartDashboard(this.filterItems);
            case 1:
              data = _context6.v;
              labels = [];
              services = [];
              datasets = [];
              if (!(data && data.length)) {
                _context6.n = 4;
                break;
              }
              data.map(function (i) {
                if (!labels.includes(i.hour)) {
                  labels.push(i.hour);
                }
                var service = i.service || 'url-invalida';
                if (!services.includes(service)) {
                  services.push(service);
                }
              });
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var service, values, _loop2, j, item;
                return _regenerator().w(function (_context5) {
                  while (1) switch (_context5.n) {
                    case 0:
                      service = services[i];
                      values = [];
                      _loop2 = /*#__PURE__*/_regenerator().m(function _loop2() {
                        var dt, item;
                        return _regenerator().w(function (_context4) {
                          while (1) switch (_context4.n) {
                            case 0:
                              dt = labels[j];
                              item = data.find(function (j) {
                                var serviceCompare = j.service || 'url-invalida';
                                return serviceCompare === service && j.hour === dt;
                              });
                              if (item) {
                                values.push(item.totalRequests);
                              } else {
                                values.push(0);
                              }
                            case 1:
                              return _context4.a(2);
                          }
                        }, _loop2);
                      });
                      j = 0;
                    case 1:
                      if (!(j < labels.length)) {
                        _context5.n = 3;
                        break;
                      }
                      return _context5.d(_regeneratorValues(_loop2()), 2);
                    case 2:
                      j++;
                      _context5.n = 1;
                      break;
                    case 3:
                      item = chartConfig.datasetObjectItem(values, service);
                      datasets.push(item);
                    case 4:
                      return _context5.a(2);
                  }
                }, _loop);
              });
              i = 0;
            case 2:
              if (!(i < services.length)) {
                _context6.n = 4;
                break;
              }
              return _context6.d(_regeneratorValues(_loop()), 3);
            case 3:
              i++;
              _context6.n = 2;
              break;
            case 4:
              this.chartData = {
                labels: labels,
                datasets: datasets
              };
              this.loadChart = false;
            case 5:
              return _context6.a(2);
          }
        }, _callee4, this);
      }));
      function fillChartData() {
        return _fillChartData.apply(this, arguments);
      }
      return fillChartData;
    }(),
    getDetailsList: function () {
      var _getDetailsList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var data;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              this.loadLastRequests = true;
              _context7.n = 1;
              return this.fetchLatestServiceCallDashboard(this.filterItems);
            case 1:
              data = _context7.v;
              if (data) {
                this.listLastRequests = data;
              }
              this.loadLastRequests = false;
            case 2:
              return _context7.a(2);
          }
        }, _callee5, this);
      }));
      function getDetailsList() {
        return _getDetailsList.apply(this, arguments);
      }
      return getDetailsList;
    }(),
    getRequestsTotals: function () {
      var _getRequestsTotals = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this = this;
        var data, values, labels, colors;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              this.loadRequestsTotals = true;
              _context8.n = 1;
              return this.fetchLatestServiceCallTotalDashboard(this.filterItems);
            case 1:
              data = _context8.v;
              if (data) {
                values = [];
                labels = [];
                colors = [];
                if (data && data.length) {
                  this.listRequestsTotalsxlistRequestM = [];
                  data.map(function (i) {
                    labels.push(i.service);
                    values.push(i.totalRequests);
                    colors.push(chartConfig.getRandomColor());
                    var item = {
                      label: (i.service || '').toUpperCase(),
                      total: i.totalRequests,
                      billing: 0
                    };
                    _this.listRequestsTotalsxlistRequestM.push(item);
                  });
                }
                this.chartRequestsTotal = {
                  labels: labels,
                  datasets: [{
                    backgroundColor: colors,
                    data: values
                  }]
                };
                this.loadRequestsTotals = false;
              }
              this.loadRequestsTotals = false;
            case 2:
              return _context8.a(2);
          }
        }, _callee6, this);
      }));
      function getRequestsTotals() {
        return _getRequestsTotals.apply(this, arguments);
      }
      return getRequestsTotals;
    }(),
    getRequestsTotalsMonetizables: function () {
      var _getRequestsTotalsMonetizables = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _this2 = this;
        var data, values, labels, colors;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              this.loadRequestsTotalsMonetizables = true;
              _context9.n = 1;
              return this.fetchLatestServiceCallTotalMonetizablesDashboard(this.filterItems);
            case 1:
              data = _context9.v;
              if (data) {
                values = [];
                labels = [];
                colors = [];
                if (data && data.length) {
                  data.map(function (i) {
                    labels.push(i.service);
                    values.push(i.totalRequests);
                    colors.push(chartConfig.getRandomColor());
                    _this2.listRequestsTotalsxlistRequestM = _this2.listRequestsTotalsxlistRequestM.map(function (b) {
                      if (b.label === i.service.toUpperCase()) {
                        var item = {
                          label: b.label,
                          total: b.total,
                          billing: i.totalRequests
                        };
                        return item;
                      }
                      return b;
                    });
                  });
                }
                this.chartRequestsMonetizablesTotal = {
                  labels: labels,
                  datasets: [{
                    backgroundColor: colors,
                    data: values
                  }]
                };
                this.generateCompare();
              }
              this.loadRequestsTotalsMonetizables = false;
            case 2:
              return _context9.a(2);
          }
        }, _callee7, this);
      }));
      function getRequestsTotalsMonetizables() {
        return _getRequestsTotalsMonetizables.apply(this, arguments);
      }
      return getRequestsTotalsMonetizables;
    }(),
    generateCompare: function () {
      var _generateCompare = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var labels, totals, billings, erros, errosList, list, datasets;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              labels = [];
              totals = [];
              billings = [];
              erros = [];
              errosList = this.details.listNotFetchs;
              this.listRequestsTotalsxlistRequestM.map(function (i) {
                labels.push(i.label);
                totals.push(i.total);
                billings.push(i.billing);
                var verifyError = errosList.find(function (e) {
                  return e.service.toUpperCase() === i.label.toUpperCase();
                });
                if (verifyError) {
                  erros.push(verifyError.totalErrors);
                } else {
                  erros.push(0);
                }
              });
              list = ['Total', 'Sucesso', 'Erros'];
              datasets = [];
              list.map(function (i) {
                var values = null;
                var color = chartConfig.getRandomColor();
                var colorBack = chartConfig.transparentize(color);
                if (i === 'Total') values = totals;
                if (i === 'Sucesso') values = billings;
                if (i === 'Erros') {
                  values = erros;
                  color = 'rgb(255 0 0)';
                  colorBack = chartConfig.transparentize(color);
                }
                var item = _objectSpread(_objectSpread({}, chartConfig.datasetObjectItem(values, i, color)), {}, {
                  backgroundColor: colorBack
                });
                datasets.push(item);
              });
              if (datasets.length) {
                this.chartRequestsCompare = {
                  labels: labels,
                  datasets: datasets
                };
              }
            case 1:
              return _context0.a(2);
          }
        }, _callee8, this);
      }));
      function generateCompare() {
        return _generateCompare.apply(this, arguments);
      }
      return generateCompare;
    }(),
    goBack: function goBack() {
      this.$router.back();
    }
  })
};